export default __webpack_public_path__ + "static/media/css.4f50b33a.svg";